type ClientResponseProps = {
  id: number | string,
  firstName: string,
  lastName: string,
  patronymic?: string,
  email?: string,
  phoneNumber: string,
  address?: string,
  street?: string,
  appartment?: string,
  gender?: number,
  city?: string,
  region?: string,
  country?: string,
  postalCode?: string,
  birthDate?: string,
  additionalInformation?: string,
  companyName?: string,
  companyNumber?: string,
};

export const exampleClientResponse: ClientResponseProps = {
  id: 1,
  firstName: 'John',
  lastName: 'Doe',
  patronymic: 'Doe',
  email: 'example@gmail.com',
  phoneNumber: '+380123456789',
  address: 'Some address',
  street: 'Some street',
  appartment: 'Some appartment',
  gender: 1,
  city: 'Some city',
  region: 'Some region',
  country: 'Some country',
  postalCode: '12345',
  birthDate: '01.01.1970',
  additionalInformation: 'Some additional information',
};
export const exampleLegalClientResponse: ClientResponseProps = {
  id: 1,
  firstName: 'John',
  lastName: 'Doe',
  patronymic: 'Doe',
  email: 'example@gmail.com',
  phoneNumber: '+380123456789',
  address: 'Some address',
  street: 'Some street',
  appartment: 'Some appartment',
  gender: 1,
  city: 'Some city',
  region: 'Some region',
  country: 'Some country',
  postalCode: '12345',
  birthDate: '01.01.1970',
  additionalInformation: 'Some additional information',
  companyName: 'Some company name',
  companyNumber: 'Some company number',
};

export default ClientResponseProps;